import {
  store,
  listenerMiddleware,
  startAppListening
} from './query-store';
import notificationObserver from './query-listeners';

export { listenerMiddleware, startAppListening, notificationObserver };
export default store;
